export function isGeneralAdminView(user, demoMode = false) {
  return !demoMode && ["admin", "superadmin"].includes(user?.role);
}

export function requestedReadStores(user, selection, stores, demoMode = false) {
  if (!user) return [];
  if (demoMode && ["admin", "superadmin"].includes(user.role)) return stores.map(store => Number(store.id));
  if (!isGeneralAdminView(user, demoMode)) return [Number(user.storeId)].filter(Boolean);
  if (selection === "all") return stores.map(store => Number(store.id));
  const selected = Number(selection);
  return stores.some(store => Number(store.id) === selected) ? [selected] : [];
}
